import script from "./PhoneInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneInput.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneInput.vue?vue&type=style&index=0&id=25c5f37c&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25c5f37c"]])

export default __exports__